"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findingFilterSchema = void 0;
const QueryBuilder_1 = require("../QueryBuilder");
const design_object_filter_where_1 = require("./design-object-filter-where");
exports.findingFilterSchema = (0, QueryBuilder_1.createFilterSchema)({
    fields: {
        findingNumber: {
            options: { type: QueryBuilder_1.FieldType.Number },
            description: 'Per-owner finding sequence number rendered as FINDING-N.',
        },
        severity: {
            options: { type: QueryBuilder_1.FieldType.Number },
            description: 'Projected severity for the finding.',
        },
        workflowState: {
            options: { type: QueryBuilder_1.FieldType.Number },
            description: 'Projected workflow state.',
        },
        message: {
            options: { type: QueryBuilder_1.FieldType.String },
            description: 'Latest projected user-facing message.',
        },
        description: {
            options: { type: QueryBuilder_1.FieldType.String },
            description: 'Latest projected long-form description.',
        },
        designObject: {
            options: { type: QueryBuilder_1.FieldType.Custom, buildWhere: design_object_filter_where_1.buildDesignObjectWhere },
            allowedOperators: ['is', 'not', 'isAnyOf', 'isNoneOf', 'isEmpty', 'isNotEmpty'],
            description: 'Exact transitive design object linked through the finding log entries.',
        },
        latestLogEntryAt: {
            options: { type: QueryBuilder_1.FieldType.Date },
            description: 'Timestamp of the most recent contributing log entry (sortable).',
        },
        createdAt: {
            options: { type: QueryBuilder_1.FieldType.Date },
            description: 'Row creation timestamp.',
        },
        updatedAt: {
            options: { type: QueryBuilder_1.FieldType.Date },
            description: 'Row update timestamp.',
        },
    },
});
//# sourceMappingURL=finding-filter-schema.js.map